module.exports = __webpack_public_path__ + "static/img/v4.d9c7c5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v4.jpg
// module id = skqp
// module chunks = 1